import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";
import { Eye, SignOut } from "@phosphor-icons/react";

const API = process.env.REACT_APP_BACKEND_URL;

/**
 * Subtle "Private Preview" indicator shown when the visitor has an active
 * preview session while PUBLIC_SITE_MODE=coming-soon. Fixed bottom-left.
 */
export default function PreviewBadge({ onExit }) {
  const { i18n } = useTranslation();
  const isNl = i18n.language === "nl";

  const handleExit = async () => {
    try {
      await fetch(`${API}/api/preview/logout`, { method: "POST", credentials: "include" });
    } catch {}
    onExit?.();
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 12 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.4, duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
      className="fixed bottom-5 left-5 z-[80] flex items-center gap-2 rounded-full border border-bht-gold/25 bg-bht-void/85 py-1.5 pl-3 pr-1.5 text-xs backdrop-blur-md shadow-[0_10px_40px_-10px_rgba(0,0,0,0.6)]"
      data-testid="preview-badge"
    >
      <Eye size={13} weight="regular" className="text-bht-gold" />
      <span className="font-mono text-[10px] uppercase tracking-[0.18em] text-bht-gold/90">
        {isNl ? "Privé preview" : "Private preview"}
      </span>
      <button
        type="button"
        onClick={handleExit}
        className="inline-flex items-center gap-1 rounded-full border border-white/10 bg-white/[0.03] px-2.5 py-1 text-[10px] uppercase tracking-widest text-white/80 hover:border-bht-gold/50 hover:text-bht-gold"
        data-testid="preview-badge-exit"
        aria-label={isNl ? "Preview verlaten" : "Exit preview"}
      >
        <SignOut size={11} weight="regular" />
        {isNl ? "Verlaten" : "Exit"}
      </button>
    </motion.div>
  );
}
